module.exports = __webpack_public_path__ + "media/a4.892e5ed5.mp4";